const roleEnum = Object.freeze({
    ADMIN: 1,
    CUSTOMER: 2,
    DELIVERY_BOY: 3,
    WAITER: 4,
    CHEF: 5
});
export default roleEnum;
